import React from "react";

const EnquirerInfo = ({ formData, handleChange, setActiveTab, errors = {}, onNext }) => {
    return (
        <div id="inquirer-info" className="content">
            <div className="row g-3 justify-content-center">
                {/* Contact Method */}
                <div className="col-md-12">
                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">Contact Method</small>
                    <div className="row g-2">
                        {["Phone", "Walk-In", "Social Media", "Appointment"].map((option) => (
                            <div className="col-md-3 col-sm-6" key={option}>
                                <div className="form-check mb-2">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="contactMethod"
                                        id={`contact-${option}`}
                                        value={option}
                                        checked={formData.contactMethod === option}
                                        onChange={handleChange}
                                    />
                                    <label className="form-check-label" htmlFor={`contact-${option}`}>
                                        {option}
                                    </label>
                                </div>
                            </div>
                        ))}
                    </div>
                    {errors.contactMethod && (
                        <small className="text-danger d-block text-center mt-2">
                            {errors.contactMethod}
                        </small>
                    )}
                </div>
                {/* Inquirer Information Header */}
                <div className="col-12">
                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mt-3">Inquirer Information</small>
                </div>
                {/* Left Column */}
                <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="text"
                            className={`form-control ${errors.inquirerName ? 'is-invalid' : ''}`}
                            name="inquirerName"
                            value={formData.inquirerName}
                            onChange={handleChange}
                            placeholder="Inquirer Name"
                        />
                        <label>Inquirer Name</label>
                        {errors.inquirerName && (
                            <div className="invalid-feedback">{errors.inquirerName}</div>
                        )}
                    </div>
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="tel"
                            className={`form-control ${errors.phone1 ? 'is-invalid' : ''}`}
                            name="phone1"
                            value={formData.phone1}
                            onChange={handleChange}
                            placeholder="Phone 1"
                        />
                        <label>Phone 1</label>
                        {errors.phone1 && (
                            <div className="invalid-feedback">{errors.phone1}</div>
                        )}
                    </div>
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="tel"
                            className="form-control"
                            name="phone2"
                            value={formData.phone2}
                            onChange={handleChange}
                            placeholder="Phone 2"
                        />
                        <label>Phone 2</label>
                    </div>
                </div>
                {/* Right Column */}
                <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-3">
                        <select
                            name="relationWithClient"
                            className={`form-select ${errors.relationWithClient ? 'is-invalid' : ''}`}
                            value={formData.relationWithClient}
                            onChange={handleChange}
                        >
                            <option value="">Select Relation</option>
                            <option value="Father">Father</option>
                            <option value="Mother">Mother</option>
                            <option value="Brother">Brother</option>
                            <option value="Sister">Sister</option>
                            <option value="Spouse">Spouse</option>
                            <option value="Guardian">Guardian</option>
                        </select>
                        <label>Relation with Client</label>
                        {errors.relationWithClient && (
                            <div className="invalid-feedback">
                                {errors.relationWithClient}
                            </div>
                        )}
                    </div>
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="email"
                            className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="Email Address"
                        />
                        <label>Email Address</label>
                        {errors.email && (
                            <div className="invalid-feedback">{errors.email}</div>
                        )}
                    </div>
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="text"
                            className="form-control"
                            name="address"
                            value={formData.address}
                            onChange={handleChange}
                            placeholder="Address"
                        />
                        <label>Address</label>
                    </div>
                </div>
                {/* Finance Information Header */}
                <div className="col-12">
                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mt-3">Finance Information</small>
                </div>
                {/* Left Column Finance */}
                <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="text"
                            className="form-control"
                            name="amount"
                            value={formData.amount || ""}
                            onChange={handleChange}
                            placeholder="Amount"
                        />
                        <label>Amount</label>
                    </div>
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="text"
                            className="form-control"
                            name="reference_no"
                            value={formData.reference_no || ""}
                            onChange={handleChange}
                            placeholder="Reference No"
                        />
                        <label>Reference No</label>
                    </div>
                </div>
                {/* Right Column Finance */}
                <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-3">
                        <select
                            name="payment_status"
                            className="form-select"
                            value={formData.payment_status || ""}
                            onChange={handleChange}
                        >
                            <option value="">Select Status</option>
                            <option value="Paid">Paid</option>
                            <option value="unpaid">Unpaid</option>
                        </select>
                        <label>Payment Status</label>
                    </div>
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="date"
                            className="form-control"
                            name="payment_date"
                            value={formData.payment_date || ""}
                            onChange={handleChange}
                        />
                        <label>Payment Date</label>
                    </div>
                </div>
                {/* How did you hear about us */}
                <div className="col-md-12">
                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                        How did you hear about us?
                    </small>
                    <div className="row g-2">
                        {[
                            "Referred by: Psychiatrist",
                            "Referred by: Psychologist",
                            "Referred by: Medical Practitioner",
                            "Marketing Sources: Brochure/Flyer",
                            "Advertisement",
                            "Social Media of TRH",
                            "Website",
                            "TV",
                            "Seminar/Event",
                            "Saw the Signboard",
                            "Word of Mouth",
                            "Other"
                        ].map((option) => {
                            const isReferred =
                                option.includes("Referred by:") &&
                                formData.howHeard.includes(option);
                            const isOther =
                                option === "Other" &&
                                formData.howHeard.includes("Other");
                            const inputId = `howHeard-${option.replace(/\s+/g, '-')}`;

                            return (
                                <div className="col-md-4 col-sm-6" key={option}>
                                    <div className="form-check mb-2">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            name="howHeard"
                                            id={inputId}
                                            value={option}
                                            checked={formData.howHeard.includes(option)}
                                            onChange={handleChange}
                                        />
                                        <label className="form-check-label" htmlFor={inputId}>
                                            {option.replace("Referred by: ", "").replace("Marketing Sources: ", "")}
                                        </label>
                                    </div>

                                    {/* Conditional Fields Below Each Option */}
                                    {isReferred && (
                                        <div className="form-floating form-floating-outline mb-2">
                                            <input
                                                type="text"
                                                className="form-control"
                                                name={
                                                    option.includes("Psychiatrist")
                                                        ? "referredBy.psychiatrist"
                                                        : option.includes("Psychologist")
                                                            ? "referredBy.psychologist"
                                                            : "referredBy.otherMedical"
                                                }
                                                value={
                                                    option.includes("Psychiatrist")
                                                        ? formData.referredBy.psychiatrist
                                                        : option.includes("Psychologist")
                                                            ? formData.referredBy.psychologist
                                                            : formData.referredBy.otherMedical
                                                }
                                                onChange={handleChange}
                                                placeholder="Name"
                                            />
                                            <label>Name</label>
                                        </div>
                                    )}

                                    {isOther && (
                                        <div className="form-floating form-floating-outline mb-2">
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="otherSource"
                                                value={formData.otherSource}
                                                onChange={handleChange}
                                                placeholder="Other"
                                            />
                                            <label>Other</label>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>

                {/* Navigation Button */}
                <div className="col-12 d-flex justify-content-end mt-2">
                    <div className="col-md-2">
                        <button
                            type="button"
                            className="btn btn-primary btn-sm btn-next w-100"
                            onClick={onNext}
                        >
                            Next <i className="ri-arrow-right-line"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EnquirerInfo;